/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Organization } from '../models/organization';


/**
 * API for browse and manage organizations.
 */
@Injectable({
  providedIn: 'root',
})
export class OrganizationsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listOrganizations
   */
  static readonly ListOrganizationsPath = '/organizations';

  /**
   * List organizations available for browsing.
   *
   * Provides list of organizations. Organizations are returned as unordered list.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listOrganizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOrganizations$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Organization>>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsService.ListOrganizationsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Organization>>;
      })
    );
  }

  /**
   * List organizations available for browsing.
   *
   * Provides list of organizations. Organizations are returned as unordered list.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listOrganizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOrganizations(params?: {
  },
  context?: HttpContext

): Observable<Array<Organization>> {

    return this.listOrganizations$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Organization>>) => r.body as Array<Organization>)
    );
  }

  /**
   * Path part for operation createOrganization
   */
  static readonly CreateOrganizationPath = '/organizations';

  /**
   * Create new organization.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrganization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrganization$Response(params: {

    /**
     * Organization to be created
     */
    body: Organization
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Organization>> {

    const rb = new RequestBuilder(this.rootUrl, OrganizationsService.CreateOrganizationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Organization>;
      })
    );
  }

  /**
   * Create new organization.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOrganization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrganization(params: {

    /**
     * Organization to be created
     */
    body: Organization
  },
  context?: HttpContext

): Observable<Organization> {

    return this.createOrganization$Response(params,context).pipe(
      map((r: StrictHttpResponse<Organization>) => r.body as Organization)
    );
  }

}
